module.exports = __webpack_public_path__ + "img/arrival-detail.e7c27bbd.svg";